/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * HTTP 实例初始化
 * 基于 @iap/kit-http 创建统一的网络请求实例
 */

import Http from "@iap/kit-http";
import type { HttpConfig, HttpResponse } from "@iap/kit-http";
import { getAppConfig } from "@/betby/infrastructure/config/appConfig";
import { initEncryptConfig } from "@/betby/config/encrypt.config";
import { customErrorHandler } from "@/betby/api/errorHandler";
import {
  buildHttpHeaderBasic,
  getRequestHeaders,
} from "@/betby/api/requestHeaders";
import {
  checkAndRefreshToken,
  startTokenRefreshTimer,
} from "@/betby/api/tokenRefresh";
import { logger } from "@/betby/api/httpLogger";

initEncryptConfig();

const http = new Http({
  baseUrl: getAppConfig().api.baseUrl,
  encryptionType: "RSA",
  httpLib: "alova",
  headerBasic: buildHttpHeaderBasic(),
  setErrorHandler: customErrorHandler as any,
});

http.setInterceptor({
  errorInterceptor: (error: any) => {
    logger.error("请求错误:", error);
  },
});

export function syncHttpClientConfig(): void {
  const config = getAppConfig();
  // Http 实例是单例，配置热更新时只同步可变项，避免重新创建拦截器和内部状态。
  Reflect.set(http as object, "baseUrl", config.api.baseUrl);
  http.setHeaderBasic(buildHttpHeaderBasic());
}

export { checkAndRefreshToken, getRequestHeaders, startTokenRefreshTimer };

export default http;
export type { HttpResponse, HttpConfig };
